import { Link } from "react-router-dom";
import { motion, useReducedMotion } from "framer-motion";
import { useApi } from "@/lib/api";
import { GridSkeleton, ProductCard, StoreNotice } from "@/components/ProductCard";
import { EASE, Reveal } from "@/components/Reveal";
import { Featured } from "@/components/home/Featured";

export const SectionHead = ({ eyebrow, title, count, link }) => (
  <div className="mb-10 flex items-end justify-between gap-6 border-b pb-5 md:mb-14">
    <Reveal>
      <p className="label text-[#111111]/60">{eyebrow}</p>
      <h2 className="mt-3 text-5xl font-bold uppercase leading-[0.85] tracking-[-0.06em] sm:text-6xl lg:text-8xl">
        {title}
        {count != null && <sup className="label ml-2 align-top text-[11px] tracking-[0.1em] text-[#E2541B]">({String(count).padStart(2, "0")})</sup>}
      </h2>
    </Reveal>
    {link && (
      <Reveal delay={0.1}>
        <Link to={link.to} data-testid={link.testid} className="label draw-link mb-2 whitespace-nowrap hover:text-[#E2541B]">{link.label}</Link>
      </Reveal>
    )}
  </div>
);

export const LatestDrop = () => {
  const { data, loading, error } = useApi("/shop/products?first=8");
  const reduce = useReducedMotion();
  const products = Array.isArray(data) ? data : [];
  return (
    <section id="latest-drop" className="mx-auto max-w-[1600px] scroll-mt-24 px-4 py-24 md:px-8 md:py-36">
      <SectionHead eyebrow="Just landed" title="Latest Drop" count={products.length || null} link={{ to: "/shop", label: "View all", testid: "latest-drop-view-all" }} />
      {loading && <GridSkeleton />}
      {error && <StoreNotice error={error} />}
      {!loading && !error && products.length === 1 && <Featured p={products[0]} />}
      {!loading && !error && products.length > 1 && (
        <div data-testid="latest-drop-grid" className="grid grid-cols-2 gap-x-3 gap-y-10 md:grid-cols-4 md:gap-x-5 md:gap-y-14">
          {products.map((p, i) => (
            <motion.div
              key={p.id}
              initial={reduce ? false : { opacity: 0, y: 32 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.1 }}
              transition={{ duration: 0.7, ease: EASE, delay: (i % 4) * 0.08 }}
            >
              <ProductCard product={p} index={i} />
            </motion.div>
          ))}
        </div>
      )}
    </section>
  );
};
